import { Router } from '@search/router/src/Router';
import { NewBuildingCardRoute } from '@search/nb-routes/src/NewBuildingCardRoute';
import { NewBuildingConstructionRoute } from '@search/nb-routes/src/NewBuildingConstructionRoute';
import { NewBuildingQuizRoute } from '@search/nb-routes/src/NewBuildingQuizRoute';
import { NewBuildingSearchRoute } from '@search/nb-routes/src/NewBuildingSearchRoute';
import { NewBuildingSearchMapRoute } from '@search/nb-routes/src/NewBuildingSearchMapRoute';
import { NewBuildingSearchMapTileRoute } from '@search/nb-routes/src/NewBuildingSearchMapTileRoute';
import { DeveloperRoute } from '@search/nb-routes/src/DeveloperRoute';
import { DeveloperSearchRoute } from '@search/nb-routes/src/DeveloperSearchRoute';

import { RootRegions } from '@search/vtbeco-frontend-core/domain/newbuilding/libs/root-regions';

import type { Shared } from '../../../types/shared';

export const linkBuilder = (rootRegions: RootRegions, router: Router<Shared.IRouterContext>): Shared.ILinkBuilder => ({
    search(params) {
        const searchRoute = router.route(NewBuildingSearchRoute);

        return searchRoute.url(params);
    },
    searchMap(params) {
        const searchMapRoute = router.route(NewBuildingSearchMapRoute);

        return searchMapRoute.url(params);
    },
    tile(params) {
        const searchMapTileRoute = router.route(NewBuildingSearchMapTileRoute);

        return searchMapTileRoute.url(params);
    },
    card(params) {
        const newBuildingCardRoute = router.route(NewBuildingCardRoute);

        return newBuildingCardRoute.url(params);
    },
    construction(params) {
        const newBuildingConstructionRoute = router.route(NewBuildingConstructionRoute);

        return newBuildingConstructionRoute.url(params);
    },
    quiz(params) {
        const newBuildingQuizRoute = router.route(NewBuildingQuizRoute);

        return newBuildingQuizRoute.url(params);
    },
    developer(params) {
        try {
            const developerRoute = router.route(DeveloperRoute);

            return developerRoute.url(params);
        } catch {
            return '';
        }
    },
    developerSearch(params) {
        try {
            const developerSearchRoute = router.route(DeveloperSearchRoute);

            return developerSearchRoute.url(params);
        } catch {
            return '';
        }
    },
    external(url) {
        return url;
    }
});
